/**
 * EVLegend.tsx — EV charger level legend (T-012/W1 Task 6).
 *
 * Shown only when the EV charger layer is enabled. Colors match the
 * level-coded markers EVChargerLayer renders in Wave 2 (green = DC Fast,
 * blue = Level 2, slate = Level 1).
 */
const LEVELS = [
  { label: 'DC Fast', color: '#16a34a' },
  { label: 'Level 2', color: '#2563eb' },
  { label: 'Level 1', color: '#94a3b8' },
]

export function EVLegend() {
  return (
    <div className="glass rounded-lg border border-border/60 shadow-md px-2.5 py-2 text-[10px] w-48">
      <p className="font-semibold text-muted-foreground mb-1">⚡ EV Chargers</p>
      <div className="space-y-0.5">
        {LEVELS.map((l) => (
          <div key={l.label} className="flex items-center gap-1.5">
            <span
              className="w-2 h-2 rounded-full shrink-0"
              style={{ backgroundColor: l.color }}
              aria-hidden="true"
            />
            <span className="text-muted-foreground">{l.label}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
